import React from "react";
import { Field } from "redux-form";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FilledInput from "@material-ui/core/FilledInput";
import { makeStyles } from "@material-ui/core/styles";

const useLabelStyles = makeStyles({
  root: {
    color: "white",
    marginLeft: 0,
    "&$focused": {
      color: "white",
    },
  },
  icon: {
    color: "white",
    height: "24px",
    width: "24px",
  },
  focused: {
    color: "white",
  },
  error: {
    backgroundColor: "transparent",
  },
  selectMenu: {
    paddingLeft: "10px",
    color: "white",
    height: "1.26em",
  },
});

const renderSelectField = ({
  input,
  label,
  meta: { touched, error, invalid },
  children,
  name,
  labelStyles,
  ...custom
}) => {
  return (
    <div data-testid="language-selector" className="global-input-wrapper">
      <FormControl
        data-testid="language-selector-formcontrol"
        error={touched && error}
        style={{ backgroundColor: "rgb(36, 48, 65)" }}
        fullWidth
      >
        <InputLabel
          data-testid="language-selector-label"
          htmlFor={name}
          classes={{
            root: labelStyles.root,
            focused: labelStyles.focused,
          }}
          variant="filled"
        >
          {label}
        </InputLabel>
        <Select
          data-testid="language-selector-select"
          fullWidth
          error={touched && invalid}
          errorText={touched && error}
          {...input}
          {...custom}
          inputProps={{
            name: name,
            id: name,
          }}
          classes={{
            icon: labelStyles.icon,
            selectMenu: labelStyles.selectMenu,
          }}
          input={
            <FilledInput
              id={name}
              name={name}
              style={{ padding: 0, color: "white" }}
            />
          }
        >
          {children}
        </Select>
      </FormControl>
      {touched && error && (
        <div
          data-testid="language-selector-error"
          style={{
            color: "red",
            margin: "8px 16x",
            fontSize: "14px",
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

const LanguageSelector = ({
  label,
  name,
  onChange,
  data,
  classes,
  validators,
  ...other
}) => {
  var labelStyles = useLabelStyles();
  return (
    <Field
      data-testid="language-selector-field"
      component={renderSelectField}
      name={name}
      onChange={onChange}
      label={label}
      labelStyles={labelStyles}
      validate={validators}
      {...other}
    >
      {data &&
        data.map((r) => (
          <MenuItem
            data-testid="language-selector-menu-item"
            key={r.languageId}
            value={r.languageId}
          >
            {r.displayName}
          </MenuItem>
        ))}
    </Field>
  );
};

export default LanguageSelector;
